export default __webpack_public_path__ + "static/sharing-view-b58be59a7cf70e0fdf19cac4a7d9a27a.png";